/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Appointment_Booked_ForInputs */

const en_appointment_booked_for = /** @type {(inputs: Appointment_Booked_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appointment booked for`)
};

const de_appointment_booked_for = /** @type {(inputs: Appointment_Booked_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termin gebucht für den`)
};

/**
* | output |
* | --- |
* | "Appointment booked for" |
*
* @param {Appointment_Booked_ForInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const appointment_booked_for = /** @type {((inputs?: Appointment_Booked_ForInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Appointment_Booked_ForInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_appointment_booked_for(inputs)
	return en_appointment_booked_for(inputs)
});